// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"61b8ef9e","773":"9f10272b"}[chunkId] + ".chunk.js";
};